import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import moment from "moment";
import { Form, InputGroup } from "react-bootstrap";


export default function AgentPerformance() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [agents, setAgents] = useState([]);

    // ✅ Date filter state (default last 30 days)
    const [dateFrom, setDateFrom] = useState(
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [dateTo, setDateTo] = useState(
        moment().format("YYYY-MM-DD")
    );

    const loadData = () => {
        setLoading(true);

        axios.get(
            `https://${process.env.REACT_APP_IP}/api/orders/stats/salesbyrep`,
            {
                headers: { Authorization: `bearer ${user.token}` },
                params: {
                    dateFrom: dateFrom,
                    dateTo: dateTo
                }
            }
        )
            .then((res) => {
                setAgents(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response?.status === 401) {
                    dispatch({ type: "LOGOUT" });
                    navigate("../");
                }
            });
    };

    // ✅ Load on first render
    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="page">
            <div className="row">
                <div className="col-12">

                    {loading && (<Spinner />)}

                    {!loading && (
                        <>
                            <h1>Volume &amp; Contribution By Agent</h1>


                            <div style={{ marginBottom: "20px" }} className="filterBox">
                                <div className="row">
                                    <div className="col-12">
                                        <h5>Filter Options</h5>
                                    </div>
                                </div>

                                <div className="row">
                                    { /* Date - Greater Than */}
                                    <div className="form-group col-3">
                                        <label>Date</label>
                                        <InputGroup>
                                            <InputGroup.Text>After</InputGroup.Text>

                                            <Form.Control
                                                required
                                                type="date"
                                                placeholder="e.g 25/12/2024"
                                                onChange={(e) => setDateFrom(e.target.value)}
                                                value={dateFrom}
                                            />
                                        </InputGroup>
                                    </div>

                                    { /* Date - Less Than */}
                                    <div className="form-group col-3">
                                        <label>Date</label>
                                        <InputGroup>
                                            <InputGroup.Text>Before</InputGroup.Text>

                                            <Form.Control
                                                required
                                                type="date"
                                                placeholder="e.g 25/12/2024"
                                                onChange={(e) => setDateTo(e.target.value)}
                                                value={dateTo}
                                            />
                                        </InputGroup>
                                    </div>
                                


                                    <div className="col-2">
                                        <br />
                                        <button className="btn btn-primary" onClick={loadData}>Filter</button>
                                    </div>

                                </div>
                            </div>

                            <table width="100%">
                                <thead>
                                    <tr>
                                        <td>Agent</td>
                                        <td style={{ textAlign: "right" }}>Orders</td>
                                        <td style={{ textAlign: "right" }}>Value</td>
                                        <td style={{ textAlign: "right" }}>Net Contrib.</td>
                                        <td style={{ textAlign: "right" }}>Commission</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {agents.map((agent, index) => (
                                        <tr key={index}>
                                            <td>{agent.name}</td>
                                            <td style={{ textAlign: "right" }}>{agent.sales}</td>
                                            <td style={{ textAlign: "right" }}>
                                                £{agent.revenue.toFixed()}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                £{agent.netContribution.toFixed()}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                £{agent.commission.toFixed()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Total</td>
                                        <td style={{ textAlign: "right" }}>
                                            {agents.reduce((sum, agent) => sum + agent.sales, 0)}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            £{agents.reduce((sum, agent) => sum + agent.revenue, 0).toFixed()}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            £{agents.reduce((sum, agent) => sum + agent.netContribution, 0).toFixed()}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            £{agents.reduce((sum, agent) => sum + agent.commission, 0).toFixed()}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
